<!-- ========================================
     SOURCE PANEL COMPONENT
     ======================================== -->
<div class="source-panel__container" [ngClass]="'view-mode-' + viewMode" role="complementary" aria-label="Sources Panel">

  <!-- ========================================
           PANEL HEADER
           ======================================== -->
  <header class="source-panel__header">
    <div class="source-panel__title">
      <img src="assets/images/chatbot-icon.svg" alt="Sources" class="source-panel__icon"  aria-hidden="true">
      <span class="source-panel__title-text">{{'SOURCES_PANEL_TITLE' | translate}}</span>
      <span class="source-panel__count" aria-label="Number of sources">
        {{ sourcesCount }}
      </span>
    </div>

    <button class="source-panel__close t-left t-no-arrow" (click)="closePanel()" 
      aria-label="Close sources panel" type="button">
      ×
    </button>
  </header>

  <!-- ========================================
           SEARCH AND FILTER CONTROLS
           ======================================== -->
  <section class="source-panel__filters" aria-label="Filter and view options">
    <div class="source-panel__search-container">
      <div class="source-panel__filters-container">
        <!-- View Toggle Controls -->
        <div class="source-panel__view-toggle" role="group" aria-label="View mode selection">
          <button class="source-panel__view-btn t-right t-no-arrow" [class.active]="viewMode === 'compact'"
            (click)="setViewMode('compact')" [attr.data-tooltip]="'COMPACT_VIEW_TOOLTIP' | translate"
            [attr.aria-label]="'COMPACT_VIEW_TOOLTIP' | translate"
            aria-label="Switch to compact view" type="button">
            <img src="assets/images/compact_view-icon.svg" alt="Compact View" aria-hidden="true">
          </button>

          <button class="source-panel__view-btn t-right t-no-arrow" [class.active]="viewMode === 'detailed'"
            (click)="setViewMode('detailed')" [attr.data-tooltip]="'DETAILED_VIEW_TOOLTIP' | translate"
            [attr.aria-label]="'DETAILED_VIEW_TOOLTIP' | translate"
            aria-label="Switch to detailed view" type="button">
            <img src="assets/images/detailed_view.svg" alt="Detailed View" aria-hidden="true">
          </button>
        </div>

        <!-- Filter Dropdown -->
        <div class="source-panel__filter-dropdown">
          <span class="t-bottom t-no-arrow"
                [attr.data-tooltip]="!isRelevancyEnabled ? relevancyDisabledTooltip : ( 'FILTER_BY_RELEVANCE' | translate )"
                [attr.aria-label]="!isRelevancyEnabled ? relevancyDisabledTooltip : ( 'FILTER_BY_RELEVANCE' | translate )">
            <button class="source-panel__filter-btn"
              [disabled]="!isRelevancyEnabled"
              [class.disabled]="!isRelevancyEnabled"
              position="top" tooltipClass="sm" (click)="toggleFilterDropdown($event)" aria-label="Filter by relevance"
              type="button">

              <span class="source-panel__filter-text">
                <ng-container *ngIf="selectedFilter === 'ALL'"><span class="source-panel__filter-text">
                    {{ 'ALL_BUTTON' | translate }}
                  </span></ng-container>
                <ng-container *ngIf="selectedFilter !== 'ALL' && isRelevancyEnabled">
                  <span class="relevance-dot" [ngClass]="getRelevanceDotClass(selectedFilter)"></span>
                  <span class="selected-filter">{{
                    (selectedFilter === 'MOST_RELEVANT' ? 'MOST_RELEVANCE' :
                    selectedFilter === 'MEDIUM_RELEVANT' ? 'MEDIUM_RELEVANCE' :
                    selectedFilter === 'LESS_RELEVANT' ? 'LESS_RELEVANCE' :
                    selectedFilter) | translate
                    }}
                  </span>
                </ng-container>
              </span>
              <i class="fa-solid fa-angle-down source-panel__filter-arrow" [class.open]="isFilterDropdownOpen"></i>
            </button>
          </span>

          <!-- Filter Dropdown Content -->
          <div class="source-panel__filter-content" [class.open]="isFilterDropdownOpen && isRelevancyEnabled">
            <div class="source-panel__filter-options">
              <button *ngFor="let option of filterOptions" class="source-panel__filter-option"
                [class.selected]="selectedFilter === option.label"
                [disabled]="!isRelevancyEnabled && option.label !== 'ALL'" (click)="selectFilter(option.label, $event)"
                type="button">
                <i class="fa-solid fa-check source-panel__filter-check"></i>
                <span *ngIf="option.dotClass && isRelevancyEnabled" class="relevance-dot"
                  [ngClass]="option.dotClass"></span>
                <span *ngIf="option.label === 'ALL' && selectedFilter !== 'ALL'" class="filter-option-spacer"></span>
                <span>{{
                  (option.label === 'MOST_RELEVANT' ? 'MOST_RELEVANCE' :
                  option.label === 'MEDIUM_RELEVANT' ? 'MEDIUM_RELEVANCE' :
                  option.label === 'LESS_RELEVANT' ? 'LESS_RELEVANCE' :
                  option.label === 'ALL' ? 'ALL' :
                  option.label) | translate
                  }}</span>
              </button>
            </div>
          </div>
        </div>

        <!-- Sorting Dropdown -->
        <div class="source-panel__sort-dropdown">
          <span class="t-bottom t-no-arrow source-panel__sort-tooltip" 
                [attr.data-tooltip]="!isRelevancyEnabled && !isDateEnabled ? ('SORT_OPTION_UNAVAILABLE' | translate) : ('CLICK_TO_SORT_DATA' | translate)"
                [attr.aria-label]="!isRelevancyEnabled && !isDateEnabled ? ('SORT_OPTION_UNAVAILABLE' | translate) : ('CLICK_TO_SORT_DATA' | translate)">
            <button class="source-panel__sort-btn" (click)="toggleSortDropdown($event)" aria-label="Sort options" type="button"
              [disabled]="!isRelevancyEnabled && !isDateEnabled">
              <img src="../../../assets/icons/sort-amount-dsc.svg" alt=sortingicon class="sorting-image" />
              <span class="source-panel__sort-text">
                {{ getOptionLabel(selectedOption) == 'Relevence' ? ('RELEVANCE_SPAN' | translate) : ('DATE_SPAN' | translate) }}
              </span>
              <i class="fa-solid fa-angle-down source-panel__sort-arrow" [class.open]="isSortDropdownOpen"></i>
            </button>
          </span>
          <div class="source-panel__sort-content" [class.open]="isSortDropdownOpen">
            <div class="source-panel__sort-options">
              <button *ngFor="let option of options" class="source-panel__sort-option"
                [disabled]="option.value === 'relevance' ? !isRelevancyEnabled : !isDateEnabled"
                [class.selected]="selectedOption === option.value" (click)="selectSortOption(option.value, $event)"
                type="button">
                <i class="fa-solid fa-check source-panel__sort-check"></i>
                <span>{{ 
                  ( option.label === 'Relevence' ? 'RELEVANCE_SPAN' :
                  option.label === 'Date' ? 'DATE_SPAN' :
                  option.label) | translate 
                  }}</span>
              </button>
            </div>
          </div>
        </div>
      </div>
      <!-- Search Input -->
      <div class="source-panel__search-input-wrapper">
        <img src="assets/images/search-icon.svg" alt="Search" class="source-panel__search-icon" aria-hidden="true">
        <input type="text" class="source-panel__search-input" placeholder="{{'KEYWORD_SEARCH_PLACEHOLDER' | translate}}"
          [(ngModel)]="searchQuery" (input)="filterSources()" aria-label="Search sources" autocomplete="off">
      </div>

    </div>
  </section>

  <!-- ========================================
           RELEVANCY DROPDOWN SECTION
           ======================================== -->
  <section class="relevancy-section" aria-label="Relevancy filter">
    <!-- Enabled state -->
    <div *ngIf="isRelevancyEnabled" class="relevancy-dropdown t-bottom t-no-arrow"
      [attr.data-tooltip]="'RELEVANCY_DROPDOWN_TOOLTIP' | translate"
      [attr.aria-label]="'RELEVANCY_DROPDOWN_TOOLTIP' | translate">
      <div class="relevancy-dropdown-header">
        <span class="relevancy-dropdown-title">{{'RELEVANCY_TEXT' | translate}}</span>
      </div>
      <!-- Relevancy Content -->
      <div class="relevancy-content-body">
        <div class="relevancy-bar-container">
          <!-- Relevancy Bar -->
          <div class="relevancy-bar">
            <div *ngFor="let segment of [
                    {class: 'most-relevant', width: relevancyData.mostRelevant},
                    {class: 'medium-relevant', width: relevancyData.mediumRelevant},
                    {class: 'less-relevant', width: relevancyData.lessRelevant}
                  ]" class="relevancy-segment" [ngClass]="segment.class" [style.width.%]="segment.width">
            </div>
          </div>
          <!-- Relevancy Legend -->
          <div class="relevancy-legend">
            <div *ngFor="let item of [
                    {colorClass: 'most-relevant-color', text: 'MOST_RELEVANT' | translate, value: relevancyData.mostRelevant},
                    {colorClass: 'medium-relevant-color', text: 'MEDIUM_RELEVANT' | translate, value: relevancyData.mediumRelevant},
                    {colorClass: 'less-relevant-color', text: 'LESS_RELEVANT' | translate, value: relevancyData.lessRelevant}
                  ]" class="relevancy-legend-item">
              <span class="relevancy-legend-color" [ngClass]="item.colorClass"></span>
              <span class="relevancy-legend-text">{{ item.text }} ({{ item.value }}%)</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Disabled state -->
    <div *ngIf="!isRelevancyEnabled" class="relevancy-dropdown t-bottom t-no-arrow" [class.disabled]="true"
       [attr.data-tooltip]="relevancyDisabledTooltip"
      [attr.aria-label]="relevancyDisabledTooltip" >
      <div class="relevancy-dropdown-header">
        <span class="relevancy-dropdown-title">{{'RELEVANCY_TEXT' | translate}}</span>
        <i class="fa-solid fa-angle-down relevancy-dropdown-arrow"></i>
      </div>
    </div>
  </section>

  <!-- ========================================
           PANEL MAIN CONTENT
           ======================================== -->
  <main class="source-panel__content" role="main">
    <div class="source-panel__scroll" #scrollContainer>

      <!-- ========================================
               LOADING STATE
               ======================================== -->
      <ng-container *ngIf="isLoading">
        <div class="source-panel__loading" role="status" aria-live="polite" aria-label="Loading sources">
          <div class="source-panel__loading-content">
            <p class="source-panel__loading-text">{{'LOADING_STATE_TEXT' | translate}}</p>
          </div>
        </div>
      </ng-container>

      <!-- ========================================
               NO RESULTS STATE
               ======================================== -->
      <ng-container *ngIf="sourcesCount === 0 && !isLoading">
        <div class="source-panel__no-results" role="status" aria-live="polite">
          <div class="source-panel__no-results-content">
            <!-- Empty State Icon -->
            <div class="source-panel__no-results-icon">
              <svg width="64" height="64" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"
                aria-hidden="true">
                <circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="1.5" opacity="0.3" />
                <path d="M8 8L16 16" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" opacity="0.5" />
                <path d="M16 8L8 16" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" opacity="0.4" />
              </svg>
            </div>

            <!-- No Results Message -->
            <div class="source-panel__no-results-text">
              <h3 class="source-panel__no-results-title">{{'NO_DATA_FOUND_TEXT' | translate}}</h3>
              <p class="source-panel__no-results-subtitle">
                {{'NO_DATA_FOUND_SUBTEXT' | translate}}
                <br>
                <span class="source-panel__no-results-suggestion">{{'NO_DATA_FOUND_SUGGESTION' | translate}}</span>
              </p>
            </div>
          </div>
        </div>
      </ng-container>

      <!-- ========================================
               SOURCES CONTENT
               ======================================== -->
      <ng-container *ngIf="sourcesCount > 0 && !isLoading">
        <section class="source-panel__section" aria-label="Sources list">
          <div class="source-panel__section-content">

            <ng-container *ngFor="let itemWithKey of cachedSourcesWithKeys; let i = index; trackBy: trackBySourceKey">

              <!-- ========================================
                         REGULATION ITEM
                         ======================================== -->
              <article class="regulation__item" role="article">

                <!-- Regulation Header -->
                <header class="regulation__header">

                  <!-- ========================================
                             UNIVERSAL MODULE CONTENT
                  ======================================== -->
                  <!-- Universal Module Rendering - render for all items regardless of module -->
                  <div class="regulation__universal-content">
                    
                    <!-- ID and Title Section -->
                    <div class="regulation__main-info">
                      <div class="regulation__ins-id">
                        <a target="_blank" class="regulation__ins-link"
                           [href]="getViewUrl(itemWithKey.item)" rel="noopener noreferrer"
                           [attr.aria-label]="'View ' + getDisplayId(itemWithKey.item)"
                           (click)="onIdLinkClick($event, itemWithKey.item)"
                           *ngIf="getViewUrl(itemWithKey.item)">
                          <span *ngIf="hasFieldValue(itemWithKey.item, 'relevance_score') && isRelevancyEnabled" 
                                class="relevance-dot"
                                [ngClass]="getRelevanceClass(getFieldValue(itemWithKey.item, 'relevance_score'))">
                          </span>
                          {{ getDisplayId(itemWithKey.item) }}
                        </a>
                        
                        <span *ngIf="!getViewUrl(itemWithKey.item)" class="regulation__ins-link">
                          <span *ngIf="hasFieldValue(itemWithKey.item, 'relevance_score') && isRelevancyEnabled" 
                                class="relevance-dot"
                                [ngClass]="getRelevanceClass(getFieldValue(itemWithKey.item, 'relevance_score'))">
                          </span>
                          {{ getDisplayId(itemWithKey.item) }}
                        </span>

                        <ng-container *ngIf="hasSourceReasoning(itemWithKey.item)">
                          <div class="tooltip">
                            <span class="tooltip-wrapper">
                              <img src="../../../assets/icons/info-circle.svg"
                                   alt=""
                                   class="info-icon"
                                   [attr.aria-label]="'EXPLANATION' | translate" />
                              <div class="tooltip-text">
                                <p class="tooltip-body">{{ getSourceReasoning(itemWithKey.item) }}</p>
                              </div>
                            </span>
                          </div>
                        </ng-container>
                      </div>

                      <h3 class="regulation__title" *ngIf="getDisplayTitle(itemWithKey.item)">
                        {{ itemWithKey.key }}. {{ getDisplayTitle(itemWithKey.item) }}
                      </h3>
                    </div>

                    <!-- Compact Fields for Compact View - Only ID and Title (countries handled in location section) -->
                    <ng-container *ngIf="viewMode === 'compact'">
                      <!-- Date Information (Release Date) in compact view -->
                      <ng-container *ngFor="let field of getDetailedFields(itemWithKey.item)">
                        <div *ngIf="field?.type === 'date' && hasFieldValue(itemWithKey?.item, field?.key || '')" 
                             class="regulation__date-info">
                          <span class="regulation__date-value">{{ getFormattedFieldValue(itemWithKey?.item, field) }}</span>
                        </div>
                      </ng-container>
                    </ng-container>

                    <!-- Dynamic Fields for Detailed View -->
                    <ng-container *ngIf="viewMode === 'detailed'">
                      <ng-container *ngFor="let field of getDetailedFields(itemWithKey.item)">
                        <!-- Render all discovered fields -->
                        <ng-container>
                          
                          <!-- URL fields (references) — show 2 by default, +more expands -->
                          <section class="regulation__section" *ngIf="field.type === 'url' && hasFieldValue(itemWithKey.item, field.key)"
                                   aria-label="References">
                            <h4 class="regulation__section-title">{{ field.label }}</h4>
                            <ng-container *ngIf="getReferenceUrls(itemWithKey.item, field.key) as refUrls">
                              <div class="regulation__references">
                                <div *ngFor="let url of getVisibleReferenceUrls(itemWithKey.key, field.key, refUrls); let refIndex = index; trackBy: trackByReferenceUrl"
                                     class="regulation__reference-unified">
                                  <a [href]="url" target="_blank" class="regulation__reference-pill t-top t-no-arrow" rel="noopener noreferrer"
                                     [attr.aria-label]="'Open ' + field.label.toLowerCase() + ' ' + (refIndex + 1) + ' in new tab'"
                                     (click)="onReferenceClick($event, url)">
                                    <span class="regulation__reference-text">{{url.slice(0,45)}}....</span>
                                    ↗
                                  </a>
                                </div>
                                <button *ngIf="refUrls.length > REF_LINKS_PREVIEW_COUNT"
                                        type="button"
                                        class="regulation__references-more"
                                        (click)="toggleReferencesExpanded(itemWithKey.key, field.key)"
                                        [attr.aria-expanded]="isReferencesExpanded(itemWithKey.key, field.key)">
                                  <span *ngIf="!isReferencesExpanded(itemWithKey.key, field.key)">
                                    {{ 'REF_LINKS_MORE' | translate }}
                                  </span>
                                  <span *ngIf="isReferencesExpanded(itemWithKey.key, field.key)">
                                    {{ 'REF_LINKS_SHOW_LESS' | translate }}
                                  </span>
                                </button>
                              </div>
                            </ng-container>
                          </section>

                          <!-- Text fields -->
                          <p *ngIf="field?.type === 'text' && hasFieldValue(itemWithKey?.item, field?.key || '')" 
                             class="regulation__metadata">
                            <span class="regulation__metadata-label">{{ field?.label }}</span>
                            <span class="regulation__metadata-value">{{ getFormattedFieldValue(itemWithKey?.item, field) }}</span>
                          </p>

                          <!-- Array fields -->
                          <p *ngIf="field?.type === 'array' && hasFieldValue(itemWithKey?.item, field?.key || '')" 
                             class="regulation__metadata">
                            <span class="regulation__metadata-label">{{ field?.label }}</span>
                            <span class="regulation__metadata-value">{{ getFormattedFieldValue(itemWithKey?.item, field) }}</span>
                          </p>

                          <!-- Country fields are handled in location section below, no need to show here -->
                          <!-- Download fields -->
                          <p *ngIf="field.type === 'download' && hasFieldValue(itemWithKey?.item, field?.key || '')" 
                             class="regulation__metadata">
                            <span class="regulation__metadata-label">{{ field?.label }}</span>
                            <a href="#" (click)="downloadDocument(getFieldValue(itemWithKey?.item, field?.key || '')); $event.preventDefault()">
                              {{ getFieldValue(itemWithKey?.item, field?.key || '') }}
                            </a>
                          </p>

                          <!-- Document fields — Concept 1 column table (documents[] or attachment_name) -->
                          <section class="regulation__section" *ngIf="field?.type === 'document' && hasFieldValue(itemWithKey.item, field.key)"
                                   aria-label="Documents">
                            <h4 class="regulation__section-title">{{ field.label }}</h4>
                            <ng-container *ngIf="getDocumentRows(itemWithKey.item) as docRows">
                              <div class="doc-table" *ngIf="docRows.length > 0">
                                <div class="doc-table__head">
                                  <span>{{ 'DOC_TABLE_DOCUMENT' | translate }}</span>
                                  <span>{{ 'DOC_TABLE_VERSION' | translate }}</span>
                                  <span>{{ 'DOC_TABLE_RELEASED' | translate }}</span>
                                  <span aria-hidden="true"></span>
                                </div>
                                <div class="doc-row"
                                     *ngFor="let doc of getVisibleDocumentRows(itemWithKey.key, docRows); trackBy: trackByDocumentRow">
                                  <span class="doc-name t-top t-no-arrow t-xs"
                                        [attr.data-tooltip]="getAttachmentDisplayName(doc.fileName)"
                                        [attr.aria-label]="getAttachmentDisplayName(doc.fileName)">
                                    <span>{{ getAttachmentDisplayName(doc.fileName) }}</span>
                                  </span>
                                  <span class="doc-version t-top t-no-arrow t-xs"
                                        [attr.data-tooltip]="formatDocTableCell(doc.version)"
                                        [attr.aria-label]="('DOC_TABLE_VERSION_TOOLTIP' | translate) + ': ' + formatDocTableCell(doc.version)">
                                    <span>{{ formatDocTableCell(doc.version) }}</span>
                                  </span>
                                  <span class="doc-date t-top t-no-arrow t-xs"
                                        [attr.data-tooltip]="formatDocReleaseDate(doc.releaseDate)"
                                        [attr.aria-label]="('DOC_TABLE_RELEASED_TOOLTIP' | translate) + ': ' + formatDocReleaseDate(doc.releaseDate)"
                                        tabindex="0">{{ formatDocReleaseDate(doc.releaseDate) }}</span>
                                  <div class="doc-actions">
                                    <button type="button"
                                            class="doc-download-btn t-top t-no-arrow t-xs"
                                            (mouseup)="viewFile(doc.fileName, 'sameTab', getDisplayId(itemWithKey?.item), $event)"
                                            [attr.data-tooltip]="'DOWNLOAD_TOOLTIP' | translate"
                                            [attr.aria-label]="'DOWNLOAD_TOOLTIP' | translate">
                                      <em class="icon-download" aria-hidden="true"></em>
                                    </button>
                                    <button *ngIf="isDocChat"
                                            type="button"
                                            class="doc-chat-btn t-top t-no-arrow t-xs"
                                            (mouseup)="DocChat(doc.fileName, getDisplayId(itemWithKey.item), $event)"
                                            [attr.data-tooltip]="'DOC_CHAT_TOOLTIP' | translate"
                                            [attr.aria-label]="'DOC_CHAT_TOOLTIP' | translate">
                                      <em class="icon-chat" aria-hidden="true"></em>
                                    </button>
                                  </div>
                                </div>
                                <button *ngIf="docRows.length > DOC_TABLE_PREVIEW_COUNT"
                                        type="button"
                                        class="doc-table__more"
                                        (click)="toggleDocumentsExpanded(itemWithKey.key)"
                                        [attr.aria-expanded]="isDocumentsExpanded(itemWithKey.key)">
                                  <span *ngIf="!isDocumentsExpanded(itemWithKey.key)">
                                    {{ 'DOC_TABLE_MORE' | translate:{ count: docRows.length - DOC_TABLE_PREVIEW_COUNT } }}
                                  </span>
                                  <span *ngIf="isDocumentsExpanded(itemWithKey.key)">
                                    {{ 'DOC_TABLE_SHOW_LESS' | translate }}
                                  </span>
                                  <em class="doc-table__more-chevron"
                                      [class.doc-table__more-chevron--up]="isDocumentsExpanded(itemWithKey.key)"
                                      aria-hidden="true"></em>
                                </button>
                              </div>
                            </ng-container>
                          </section>

                        </ng-container>
                      </ng-container>

                      <!-- Date Information (Release Date, etc.) - Only in detailed view -->
                      <ng-container *ngFor="let field of getDetailedFields(itemWithKey.item)">
                        <div *ngIf="field?.type === 'date' && hasFieldValue(itemWithKey?.item, field?.key || '')" 
                             class="regulation__date-info">
                          <span class="regulation__date-value">{{ getFormattedFieldValue(itemWithKey?.item, field) }}</span>
                        </div>
                      </ng-container>
                    </ng-container>

                    <!-- Brand Name Information -->
                    <div class="regulation__location" aria-label="Brand name information" 
                         *ngIf="getBrandNamesForDisplay(itemWithKey.item).length > 0">
                      <span class="regulation__location-icon-wrapper">
                        <img src="assets/images/brand-icon.svg" alt="Brand" class="regulation__location-icon"
                             width="14" height="14" aria-hidden="true">
                      </span>
                      <span class="regulation__country-text">
                        {{ displayBrandNames(getBrandNamesForDisplay(itemWithKey.item)).firstTwo }}
                      </span>
                      <span class="regulation__count-with-space"
                            *ngIf="displayBrandNames(getBrandNamesForDisplay(itemWithKey.item)).remainingCount > 0"
                            [attr.aria-label]="'Plus ' + displayBrandNames(getBrandNamesForDisplay(itemWithKey.item)).remainingCount + ' more brands'">
                        +{{ displayBrandNames(getBrandNamesForDisplay(itemWithKey.item)).remainingCount }}
                      </span>
                    </div>

                    <!-- Location Information -->
                    <div class="regulation__location" aria-label="Country information" 
                         *ngIf="getCountriesForDisplay(itemWithKey.item).length > 0">
                      <span class="regulation__location-icon-wrapper">
                        <img src="assets/images/location.svg" alt="Location" class="regulation__location-icon"
                             width="14" height="14" aria-hidden="true">
                      </span>
                      <span class="regulation__country-text">
                        {{ displayCountries(getCountriesForDisplay(itemWithKey.item)).firstTwo }}
                      </span>
                      <span class="regulation__count-with-space"
                            *ngIf="displayCountries(getCountriesForDisplay(itemWithKey.item)).remainingCount > 0"
                            [attr.aria-label]="'Plus ' + displayCountries(getCountriesForDisplay(itemWithKey.item)).remainingCount + ' more countries'">
                        +{{ displayCountries(getCountriesForDisplay(itemWithKey.item)).remainingCount }}
                      </span>
                    </div>
                  </div>


                </header>
              </article>

            </ng-container>

          </div>
        </section>
      </ng-container>

    </div>
  </main>

</div>